// src/pages/Contact.jsx
import React from 'react';

export default function Contact() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12 text-white">
      <h1 className="text-3xl font-bold text-blue-200 mb-4">Contact</h1>
      <p className="text-gray-300 mb-4">
        If you have suggestions, corrections, or questions, feel free to contact us at:
      </p>
      <p className="text-blue-300 font-semibold">contact@ee-calculator-tools.com</p>
    </div>
  );
}